import MenuIcon from '@mui/icons-material/Menu'
import { getAuthenticator, logout } from '../auth/auth';
import { cleanup } from "../auth/role"
import { useContext, useState } from 'react';
import { FeatureFlagsToggle } from './FeatureFlagsToggle';
import { Stack } from '@mui/system';
import RoleContext from '../auth/RoleContext';
import { RoleImpersonatorToggle } from './RoleImpersonatorToggle';
import { Link } from 'react-router-dom';
import SessionTools from './SessionTools';

export default function Header({appName, authenticated = false}) {
    const [account, setAccount] = useState(getAuthenticator().getCurrentAccount())
    const roleContext = useContext(RoleContext)
    

    const pushMenu = () => {
        var body = document.body;
        if(body.clientWidth > 768){
            if(body.className.indexOf('sidebar-collapse') === -1){
                body.className += ' sidebar-collapse';
            } else {
                body.className = body.className.replace(' sidebar-collapse', '');
            }
        }else{
            if (body.className.indexOf('sidebar-open') === -1) {
                body.className += ' sidebar-open';
            } else {
                body.className = body.className.replace(' sidebar-open', '');
            }
        }
    }
  
    return (
        <header className="main-header">
            <Link to="/" className="logo">
            {appName}
            </Link>
            <nav className="navbar navbar-static-top" role="navigation">
                <a href="#" className="sidebar-toggle" data-toggle="offcanvas" role="button" onClick={pushMenu}>
                    <MenuIcon/><span className="sr-only"> Toggle navigation</span>
                </a>
                {authenticated && 
                    <Stack direction='row' gap={0}>
                        {roleContext && roleContext.isAdminUserDespiteImpersonation() && <FeatureFlagsToggle />}
                        {roleContext && roleContext.isAdminUserDespiteImpersonation() && <RoleImpersonatorToggle />}
                        <SessionTools
                            layoutStyle={{ float: 'right', color: 'white', paddingRight: '2em' }}
                            linkStyle={{ color: 'white', paddingLeft: '2em' }}
                            />
                        {/* <span style={{float:"right", color:"white", paddingRight: "2em"}}>
                            <span>Welcome {account?.name || ''}!</span>
                            <span>
                                <a href="#" onClick={() => {
                                    cleanup()
                                    logout()
                                }} role="button" style={{color:"white", paddingLeft: "2em"}}>Logout</a></span>
                        </span> */}
                    </Stack>
                }
               
                {/*<div className="navbar-custom-menu">
                    <ul className="nav navbar-nav">
                        <li>
                            <a href="#" data-toggle="control-sidebar"><i className="fa fa-gears"></i></a>
                        </li>
                    </ul>
                </div>*/}
            </nav>
        </header>
    )
}